export class ImageConstants {
    static ciranetLogoImage = 'assets/images/CiraNetLogo.svg';
    static passwordToggleImage = 'assets/images/password-toggle.png';
    static ccLogo = 'assets/images/CC.png';
    static poweredByCCLogo = 'assets/images/PoweredByCC.png';
}
